/*
 * This file is part of glowingblue/orell-facade.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import AbstractFieldGroup from './AbstractFieldGroup';

export default class Visual extends AbstractFieldGroup {
	get isResponsive() {
		return true;
	}

	fields() {
		return [
			{
				name: 'image',
				type: 'image',
			},
			{
				name: 'alt',
				type: 'text',
			},
			{
				name: 'bg_color',
				type: 'color',
			},
			{
				name: 'secondary_color',
				type: 'color',
			},
		];
	}
}
